import { Reducer, Action } from 'redux';
import {
  ACTION,
  RequestExperienceTransfer, ReceiveExperienceTransfer, FailExperienceTransfer,
  RequestDeleteExperienceTransfer, ReceiveDeleteExperienceTransfer, FailDeleteExperienceTransfer,
  RequestSaveExperienceTransfer, ReceiveSaveExperienceTransfer, FailSaveExperienceTransfer,
  UpdateItem, ClearForm, UpdateValidation, ResetValidation, ClearValidation
} from './action-types';
import {
  ExperienceTransferFormState as ExperienceTransferFormState, ExperienceTransferItem
} from './types-store';
import { withOptionsReducer } from 'app/components/options-handler';
import { STATE } from 'app/constants';
import { clearValidationForKeys } from 'app/area/experience-transfer/form/utils/validation';

export const INITIAL_STATE: ExperienceTransferFormState = {
  actionType: undefined,
  experienceTransferItem: undefined,
  originalExperienceTransferItem: undefined,
  fetching: false,
  deleting: false,
  saving: false,
  validation: {}
};

const reducers: { [indexer: string]: Reducer<ExperienceTransferFormState, Action> } = {

  [ACTION.REQUEST_EXPERIENCE_TRANSFER]: (state: ExperienceTransferFormState,
    action: RequestExperienceTransfer): ExperienceTransferFormState => {

    return {
      ...state,
      experienceTransferItem: undefined,
      originalExperienceTransferItem: undefined,
      fetching: true,
      saving: false,
      validation: {}
    };
  },

  [ACTION.RECEIVE_EXPERIENCE_TRANSFER]: (state: ExperienceTransferFormState,
    action: ReceiveExperienceTransfer): ExperienceTransferFormState => {

    return {
      ...state,
      experienceTransferItem: action.item,
      originalExperienceTransferItem: action.item,
      fetching: false
    };
  },

  [ACTION.FAIL_EXPERIENCE_TRANSFER]: (state: ExperienceTransferFormState,
    action: FailExperienceTransfer): ExperienceTransferFormState => {

    return {
      ...state,
      fetching: false
    };
  },

  [ACTION.REQUEST_DELETE_EXPERIENCE_TRANSFER]: (state: ExperienceTransferFormState,
    action: RequestDeleteExperienceTransfer): ExperienceTransferFormState => {

    return {
      ...state,
      deleting: true
    };
  },

  [ACTION.RECEIVE_DELETE_EXPERIENCE_TRANSFER]: (state: ExperienceTransferFormState,
    action: ReceiveDeleteExperienceTransfer): ExperienceTransferFormState => {

    return {
      ...state,
      deleting: false
    };
  },

  [ACTION.FAIL_DELETE_EXPERIENCE_TRANSFER]: (state: ExperienceTransferFormState,
    action: FailDeleteExperienceTransfer): ExperienceTransferFormState => {

    return {
      ...state,
      deleting: false
    };
  },

  [ACTION.REQUEST_SAVE_EXPERIENCE_TRANSFER]: (state: ExperienceTransferFormState,
    action: RequestSaveExperienceTransfer): ExperienceTransferFormState => {

    return {
      ...state,
      saving: true
    };
  },

  [ACTION.RECEIVE_SAVE_EXPERIENCE_TRANSFER]: (state: ExperienceTransferFormState,
    action: ReceiveSaveExperienceTransfer): ExperienceTransferFormState => {

    return {
      ...state,
      saving: false,
      originalExperienceTransferItem: state.experienceTransferItem
    };
  },

  [ACTION.FAIL_SAVE_EXPERIENCE_TRANSFER]: (state: ExperienceTransferFormState,
    action: FailSaveExperienceTransfer): ExperienceTransferFormState => {

    return {
      ...state,
      saving: false
    };
  },

  [ACTION.UPDATE_ITEM]: (state: ExperienceTransferFormState,
    action: UpdateItem): ExperienceTransferFormState => {

    const experienceTransferItem = {
      ...(state.experienceTransferItem || {}),
      ...action.item
    } as ExperienceTransferItem;

    const validation = clearValidationForKeys(state.validation, Object.keys(action.item) as any[]);

    return {
      ...state,
      experienceTransferItem,
      validation
    };
  },

  [ACTION.CLEAR_FORM]: (state: ExperienceTransferFormState,
    action: ClearForm): ExperienceTransferFormState => {

    return {
      ...state,
      ...INITIAL_STATE
    };
  },

  [ACTION.UPDATE_VALIDATION]: (state: ExperienceTransferFormState,
    action: UpdateValidation): ExperienceTransferFormState => {
    return {
      ...state,
      validation: { ...state.validation, ...action.validation }
    };
  },

  [ACTION.RESET_VALIDATION]: (state: ExperienceTransferFormState,
    action: ResetValidation): ExperienceTransferFormState => {

    const messages = state.validation?.[action.key]?.messages?.filter?.(message =>
      message?.parameters?.id !== action.id
    );

    const validation = {
      ...(state.validation ?? {}),
      [action.key]: {
        ...state.validation?.[action.key],
        messages
      }
    };

    return {
      ...state,
      validation: Object.keys(validation)
        .reduce((result, key) => {
          if (!(key === action.key && validation?.[key]?.messages)) {
            result[key] = validation?.[key];
          }
          return result;
        }, {})
    };
  },

  [ACTION.UPDATE_VALIDATION]: (
    state: ExperienceTransferFormState,
    action: UpdateValidation
  ): ExperienceTransferFormState => {

    return {
      ...state,
      validation: { ...state.validation, ...action.validation }
    };
  },

  [ACTION.CLEAR_VALIDATION]: (state: ExperienceTransferFormState, action: ClearValidation): ExperienceTransferFormState => {
    return {
      ...state,
      validation: {}
    };
  }
};

const stateReducer: Reducer<ExperienceTransferFormState> = (
  state: ExperienceTransferFormState = INITIAL_STATE, action: Action) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};

export const reducer = withOptionsReducer(STATE.experienceTransfer, stateReducer);
